import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core/modules';
import { CompetitionGridItem } from '_competition/pages/AllCompetitionsPage/styled';
import { BTagsGrid } from 'core/components';

const MAX_COVER_IMAGE_WIDTH = '1152';

interface Props {
    isMobile?: boolean;
    isTime?: boolean;
    isHideMarginBottom?: boolean;
}

export const HeaderBlock = styled.div<Props>`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
    margin-bottom: 24px;
    margin-top: 16px;

    #tooltip-parent-element , .tooltip-parent-element {
        border-radius: 6px;
        font-size: 11px;
        line-height: 13px;
        padding: 4px 8px;
    }
    .place-top::before{
        content: none !important;
    }

    ${CompetitionGridItem} {
        margin-bottom: 0 !important;

        @media(max-width: ${LayoutConst.screen.xxxsm}px) {
            margin-bottom: 0 !important;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-direction: column;
        // gap: 40px;
        gap: 10px;
        margin-bottom: 0px;
    }
`;  

export const HeaderBlockNotAuto = styled.div<Props>`
    max-width: 1152px;
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    // padding-top: ${p => p.isMobile ? "16px" : "0"};

    .moder-button, .send-button {
        min-width: 214px;
        width: 204px;
        max-width: 204px;
        height: ${p => p.isMobile ? "46px" : "36px"};

        @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 15px;
            line-height: 20px;
            font-weight: 600;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            width: 100%;
            min-width: auto;
            max-width: 100%; 
        }
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    // @media(max-width:1280px) {
    //     max-width: 846px;
    // }

`; 

export const HeaderRightBlock = styled.div<Props>`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    .moder-button, .send-button {
        min-width: 204px;
        width: auto;
        max-width: none;
        height: ${p => p.isMobile ? "46px" : "36px"};
        white-space: nowrap;
        padding: 0 48px;
        
        @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 15px;
            line-height: 20px;
            font-weight: 600;
        }

        @media(max-width: ${LayoutConst.screen.md}px) {
            width: 100%;
            
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            width: 100%;
            min-width: auto;
            max-width: 100%;
        }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 50%;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
    }
`;

export const ButtonsWrapper = styled(FlexBox)<any>`
    margin-left: ${p => p.isMobile ? 0 : "auto"};
    .moder-button, .send-button {
        min-width: 204px;
        width: auto;
        max-width: none;
        height: ${p => p.isMobile ? "46px" : "36px"};
        white-space: nowrap;
        padding: 0 48px;
        
        @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 15px;
            line-height: 20px;
            font-weight: 600;
        }

        @media(max-width: ${LayoutConst.screen.md}px) {
            width: 100%;
            
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            width: 100%;
            min-width: auto;
            max-width: 100%;
        }
    }
    
    .statements-button {
        padding: 0;

        @media(max-width: ${LayoutConst.screen.s - 1}px){
            width: 100%;
        }
    }
`

export const SmthBanner = styled.div<Props>`
    max-width: ${MAX_COVER_IMAGE_WIDTH}px;
    // width: 90%;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-bottom: ${(p) => (p.isMobile ? null : p.isMobile ? '24px' : '30px')};
    padding-bottom: ${(p) => (p.isMobile ? '8px' : '0')};

    // img {
    //     height: ${p => p?.isMobile ? '62px' : 'inherit'};
    // }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

`;
export const SmthTitle = styled.div<Props>`
    max-width: ${(p) => (p.isMobile ? '90%' : '1152px')};
    display: flex;
    flex-flow: column;
    justify-content: flex-start;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width:940px) {
        max-width: 846px;
    }
`;

export const SmthIconsWrapper = styled.div<Props>`
    display: flex;
    //visibility: hidden;


    // @media(max-width: ${LayoutConst.screen.l_12}px) {
    //     max-width: 940px;
    // }

    // @media(max-width:940px) {
    //     max-width: 846px;
    //     padding-top:16px;
    //     display: none;
    // }
`;


export const SmthIconsWrapperNotAuto = styled.div<Props>`
    display: flex;
    visibility: hidden;


    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width:940px) {
        max-width: 846px;
        padding-top:16px;
        display: none;
    }
`;

export const TitleText = styled.div<Props>`
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    letter-spacing: -0.02em;
    color: ${p => p.theme.competition.mainText};
    font-family: 'Inter';
    margin-bottom: 24px;

    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0;
        margin-bottom: 24px;
    }
`;

export const TitleTextNotAuto = styled.div<Props>`
    font-weight: ${p => p?.isMobile ? '500' : '600'};
    font-size: ${p => p.isMobile ? "22px" : "60px"};
    line-height: ${p => p.isMobile ? "28px" : "64px"};
    letter-spacing: -0.02em;
    //color: #1F1F1F;
    color: ${p => p.theme.competition.mainText};
    font-family: 'Inter';
    margin-bottom: ${p => p.isMobile ? "24px" : "40px"};
`;

export const Logos = styled.div<Props>`
    margin: ${(p) => (p.isMobile ? '16px 0 25px' : ' 48px 0 68px')};
    display: flex;
    flex-direction: row;
    justify-content: ${(p) => (p.isMobile ? null : 'space-between')};
`;
export const SmthSubTitle = styled.div<Props>`
    opacity: 0.7;
    * {
        font-size: ${(p) => (p.isMobile ? '12px' : '20px')};
        line-height: ${(p) => (p.isMobile ? '17px' : '32px')};
        font-weight: ${(p) => (p.isMobile ? '400' : 'auto')};
    }
    margin-bottom: ${(p) => (p.isMobile ? '15px' : '48px')};
`;

export const MobileStatusPseudoTagsWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    max-width: 100%;
`;

export const CompetitionTagsContainer = styled(BTagsGrid)`
    overflow-y: auto;
    // max-height: 92px;
    max-height: 122px;
    position: relative;

    ::after {
        content: "";
        position: sticky;
        bottom: -1px;
        left: 0px;
        width: 100%;
        height: 35px;
        display: inline-block;
        background: linear-gradient(rgba(0, 0, 0, 0) 0%, ${
    // @ts-ignore
    p => p.bgColorTheme || p.theme.app.backgroundColor} 100%);
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        // max-height: 82px;
        max-height: 112px;
        ::after {
            height: 30px;
        }
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        // max-height: 80px;
        max-height: 110px;
    }
    .__react_component_tooltip {
        ::after, ::before {
            display: none;
        }
    }
        
`;
export const MainBlock = styled.div<Props & { isAcademy?: boolean }>`
    width: ${LayoutConst.container.l}px;
    max-width: ${LayoutConst.container.l}px;
    margin: 0 auto;
    // display: ${(p) => (p.isMobile ? 'block' : 'flex')};
    display: flex;
    flex-direction: column;
    margin-bottom: ${(p) => (p.isMobile ? '32px' : '64px')};
    scroll-behavior: smooth;
    place-items: center;
    padding-top: ${(p) => (p.isMobile ? '16px' : '24px')};

    .back-button {
        margin-bottom: 24px;
    }

    .grid-w {
        padding-top: 0;
    }
    
    .statements-button {
        padding: 0;
    }

    ${({ isAcademy }) => isAcademy && css`
        .dropdown-element-popup {
            background: #1f1f1f;

            .dropdown-list-item {
                background: #1f1f1f;

                * {
                    transition: background-color 0.2s;
                }
                :hover {
                    background: #2c2c2b;
                    
                    * {
                        background: #2c2c2b;
                        transition: background-color 0.2s;
                    }
                }

                .active {
                    color: #fff;
                }

                svg path {
                    fill: #fff;
                }
            }
        }
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 888px;
    }

  
    @media(max-width: ${LayoutConst.screen.md}px) {
        max-width: ${LayoutConst.container.xs}px;
        width: calc(100vw - 20px);
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin: 0 10px;
        width: calc(100% - 20px);
    }

`;

export const ActionsBlock = styled(FlexBox)`
    // width: 100%;
    // max-width: 1152px;
    // flex-flow: row;
    // padding-left: calc(100% - 48%);

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
        padding-left: calc(100% - 47.5%);
    }

    @media(max-width:1280px) {
        max-width: 846px;
        padding-left: calc(100% - 41.2%);
    }

    @media (max-width: 940px) {
        padding-left: 10px;
    }
`;

export const EmptyLayoutBlock = styled.div`
width: auto`;

export const LeftBlock = styled.div`
    max-width: 880px;
`;
export const RightBlock = styled.div<Props>`
    position: relative;
    display: ${(p) => (p.isMobile ? 'none' : 'block')};
`;
export const Tab = styled.div`
    box-sizing: border-box;
    margin-left: 25px;
    max-height: 100%;
    top: 0;
    transition: all 1s ease-in-out;
`;

export const Section = styled.div<Props>`
    display: flex;
    flex-direction: ${(p) => (p.isMobile ? 'column' : 'row')};
    margin-bottom: ${(p) => (p.isMobile ? '39px' : '64px')};
    width: 100%;
`;
export const SectionGrid = styled.div<Props>`
    display: ${(p) => (p.isMobile ? 'block' : 'grid')};
    grid-template-columns: 1fr 1fr 1fr;
    margin-bottom: 64px;
`;
export const Text = styled.div<Props>`
    margin-left: ${(p) => (p.isMobile ? null : '4vw')};
    max-width: ${(p) => (p.isMobile ? null : '588px')};
    width: ${(p) => (p.isMobile ? 'inherit' : null)};
    .text {
        margin-bottom: ${(p) => (p.isMobile ? null : '32px')};
    }
`;
export const Button = styled.button<Props>`
    color: #545453;
    border: 1px solid #cdcdcd;
    border-radius: 3px;
    padding: 12px 32px 12px 24px;
    width: ${(p) => (p.isMobile ? '100%' : null)};
    margin-top: ${(p) => (p.isMobile ? '16px' : null)};
    font-weight: 600;
    background: transparent;
    &:hover {
        color: black;
        border-color: black;
    }
`;
export const Linking = styled.a`
    color: black;
    text-decoration: underline;
    &:hover {
        color: #575b5e;
    }
`;
export const Card = styled.div<Props>`
    display: flex;
    flex-direction: column;
    max-width: ${(p) => (p.isMobile ? null : '270px')};
    width: ${(p) => (p.isMobile ? '100%' : null)};
`;
export const Photo = styled.img<Props>`
    width: ${(p) => (p.isMobile ? '100%' : '270px')};
    height: ${(p) => (p.isMobile ? '100%' : '270px')};
    background-image: ${(p) => p.src};
    margin-bottom: 16px;
`;
export const Line = styled.div<Props>`
    height: 1px;
    width: 100%;
    background-color: #575b5e;
    margin-bottom: ${(p) => (p.isMobile ? '40px' : '64px')};
    .star {
        margin: 0 auto;
        position: relative;
        bottom: 16px;
        z-index: 100;
        width: 40px;
        height: 40px;
    }
`;

export const ActionsButtonWrapper = styled(FlexBox)`
    position: relative;
     @media(max-width: ${LayoutConst.screen.s - 1}px) {
       width: 100%
    }
    .__react_component_tooltip {

        ::before {
            display: none;
        }
    }
`;
import styled, { css } from 'styled-components';
import { FlexBox } from '@brg/ui';
import { LayoutConst } from 'core/modules';
import { CompetitionGridItem } from '_competition/pages/AllCompetitionsPage/styled';
import { BTagsGrid } from 'core/components';

const MAX_COVER_IMAGE_WIDTH = '1152';

interface Props {
    isMobile?: boolean;
    isTime?: boolean;
    isHideMarginBottom?: boolean;
}

export const HeaderBlock = styled.div<Props>`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
    margin-bottom: 24px;
    margin-top: 16px;

    #tooltip-parent-element , .tooltip-parent-element {
        border-radius: 6px;
        font-size: 11px;
        line-height: 13px;
        padding: 4px 8px;
    }
    .place-top::before{
        content: none !important;
    }

    ${CompetitionGridItem} {
        margin-bottom: 0 !important;

        @media(max-width: ${LayoutConst.screen.xxxsm}px) {
            margin-bottom: 0 !important;
        }
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        flex-direction: column;
        // gap: 40px;
        gap: 10px;
        margin-bottom: 0px;
    }
`;  

export const HeaderBlockNotAuto = styled.div<Props>`
    max-width: 1152px;
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    // padding-top: ${p => p.isMobile ? "16px" : "0"};

    .moder-button, .send-button {
        min-width: 214px;
        width: 204px;
        max-width: 204px;
        height: ${p => p.isMobile ? "46px" : "36px"};

        @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 15px;
            line-height: 20px;
            font-weight: 600;
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            width: 100%;
            min-width: auto;
            max-width: 100%; 
        }
    }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    // @media(max-width:1280px) {
    //     max-width: 846px;
    // }

`; 

export const HeaderRightBlock = styled.div<Props>`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;

    .moder-button, .send-button {
        min-width: 204px;
        width: auto;
        max-width: none;
        height: ${p => p.isMobile ? "46px" : "36px"};
        white-space: nowrap;
        padding: 0 48px;
        
        @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 15px;
            line-height: 20px;
            font-weight: 600;
        }

        @media(max-width: ${LayoutConst.screen.md}px) {
            width: 100%;
            
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            width: 100%;
            min-width: auto;
            max-width: 100%;
        }
    }

    @media(max-width: ${LayoutConst.screen.md}px) {
        width: 50%;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        width: 100%;
    }
`;

export const ButtonsWrapper = styled(FlexBox)<any>`
    margin-left: ${p => p.isMobile ? 0 : "auto"};
    .moder-button, .send-button {
        min-width: 204px;
        width: auto;
        max-width: none;
        height: ${p => p.isMobile ? "46px" : "36px"};
        white-space: nowrap;
        padding: 0 48px;
        
        @media (max-width: ${LayoutConst.screen.mac13 + 'px'}), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            font-size: 15px;
            line-height: 20px;
            font-weight: 600;
        }

        @media(max-width: ${LayoutConst.screen.md}px) {
            width: 100%;
            
        }

        @media(max-width: ${LayoutConst.screen.s - 1}px) {
            width: 100%;
            min-width: auto;
            max-width: 100%;
        }
    }
    
    .statements-button {
        padding: 0;

        @media(max-width: ${LayoutConst.screen.s - 1}px){
            width: 100%;
        }
    }
`

export const SmthBanner = styled.div<Props>`
    max-width: ${MAX_COVER_IMAGE_WIDTH}px;
    // width: 90%;
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    margin-bottom: ${(p) => (p.isMobile ? null : p.isMobile ? '24px' : '30px')};
    padding-bottom: ${(p) => (p.isMobile ? '8px' : '0')};

    // img {
    //     height: ${p => p?.isMobile ? '62px' : 'inherit'};
    // }

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

`;
export const SmthTitle = styled.div<Props>`
    max-width: ${(p) => (p.isMobile ? '90%' : '1152px')};
    display: flex;
    flex-flow: column;
    justify-content: flex-start;

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width:940px) {
        max-width: 846px;
    }
`;

export const SmthIconsWrapper = styled.div<Props>`
    display: flex;
    //visibility: hidden;


    // @media(max-width: ${LayoutConst.screen.l_12}px) {
    //     max-width: 940px;
    // }

    // @media(max-width:940px) {
    //     max-width: 846px;
    //     padding-top:16px;
    //     display: none;
    // }
`;


export const SmthIconsWrapperNotAuto = styled.div<Props>`
    display: flex;
    visibility: hidden;


    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
    }

    @media(max-width:940px) {
        max-width: 846px;
        padding-top:16px;
        display: none;
    }
`;

export const TitleText = styled.div<Props>`
    font-weight: 500;
    font-size: 23px;
    line-height: 29px;
    letter-spacing: -0.02em;
    color: ${p => p.theme.competition.mainText};
    font-family: 'Inter';
    margin-bottom: 24px;

    @media(max-width: ${LayoutConst.screen.s}px) {
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0;
        margin-bottom: 24px;
    }
`;

export const TitleTextNotAuto = styled.div<Props>`
    font-weight: ${p => p?.isMobile ? '500' : '600'};
    font-size: ${p => p.isMobile ? "22px" : "60px"};
    line-height: ${p => p.isMobile ? "28px" : "64px"};
    letter-spacing: -0.02em;
    //color: #1F1F1F;
    color: ${p => p.theme.competition.mainText};
    font-family: 'Inter';
    margin-bottom: ${p => p.isMobile ? "24px" : "40px"};
`;

export const Logos = styled.div<Props>`
    margin: ${(p) => (p.isMobile ? '16px 0 25px' : ' 48px 0 68px')};
    display: flex;
    flex-direction: row;
    justify-content: ${(p) => (p.isMobile ? null : 'space-between')};
`;
export const SmthSubTitle = styled.div<Props>`
    opacity: 0.7;
    * {
        font-size: ${(p) => (p.isMobile ? '12px' : '20px')};
        line-height: ${(p) => (p.isMobile ? '17px' : '32px')};
        font-weight: ${(p) => (p.isMobile ? '400' : 'auto')};
    }
    margin-bottom: ${(p) => (p.isMobile ? '15px' : '48px')};
`;

export const MobileStatusPseudoTagsWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    max-width: 100%;
`;

export const CompetitionTagsContainer = styled(BTagsGrid)`
    overflow-y: auto;
    // max-height: 92px;
    max-height: 122px;
    position: relative;

    ::after {
        content: "";
        position: sticky;
        bottom: -1px;
        left: 0px;
        width: 100%;
        height: 35px;
        display: inline-block;
        background: linear-gradient(rgba(0, 0, 0, 0) 0%, ${
    // @ts-ignore
    p => p.bgColorTheme || p.theme.app.backgroundColor} 100%);
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        // max-height: 82px;
        max-height: 112px;
        ::after {
            height: 30px;
        }
    }

    @media(max-width: ${LayoutConst.screen.m}px) {
        // max-height: 80px;
        max-height: 110px;
    }
    .__react_component_tooltip {
        ::after, ::before {
            display: none;
        }
    }
        
`;
export const MainBlock = styled.div<Props & { isAcademy?: boolean }>`
    width: ${LayoutConst.container.l}px;
    max-width: ${LayoutConst.container.l}px;
    margin: 0 auto;
    // display: ${(p) => (p.isMobile ? 'block' : 'flex')};
    display: flex;
    flex-direction: column;
    margin-bottom: ${(p) => (p.isMobile ? '32px' : '64px')};
    scroll-behavior: smooth;
    place-items: center;
    padding-top: ${(p) => (p.isMobile ? '16px' : '24px')};

    .back-button {
        margin-bottom: 24px;
    }

    .grid-w {
        padding-top: 0;
    }
    
    .statements-button {
        padding: 0;
    }

    ${({ isAcademy }) => isAcademy && css`
        .dropdown-element-popup {
            background: #1f1f1f;

            .dropdown-list-item {
                background: #1f1f1f;

                * {
                    transition: background-color 0.2s;
                }
                :hover {
                    background: #2c2c2b;
                    
                    * {
                        background: #2c2c2b;
                        transition: background-color 0.2s;
                    }
                }

                .active {
                    color: #fff;
                }

                svg path {
                    fill: #fff;
                }
            }
        }
    `};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 888px;
    }

  
    @media(max-width: ${LayoutConst.screen.md}px) {
        max-width: ${LayoutConst.container.xs}px;
        width: calc(100vw - 20px);
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin: 0 10px;
        width: calc(100% - 20px);
    }

`;

export const ActionsBlock = styled(FlexBox)`
    // width: 100%;
    // max-width: 1152px;
    // flex-flow: row;
    // padding-left: calc(100% - 48%);

    @media(max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 940px;
        padding-left: calc(100% - 47.5%);
    }

    @media(max-width:1280px) {
        max-width: 846px;
        padding-left: calc(100% - 41.2%);
    }

    @media (max-width: 940px) {
        padding-left: 10px;
    }
`;

export const EmptyLayoutBlock = styled.div`
width: auto`;

export const LeftBlock = styled.div`
    max-width: 880px;
`;
export const RightBlock = styled.div<Props>`
    position: relative;
    display: ${(p) => (p.isMobile ? 'none' : 'block')};
`;
export const Tab = styled.div`
    box-sizing: border-box;
    margin-left: 25px;
    max-height: 100%;
    top: 0;
    transition: all 1s ease-in-out;
`;

export const Section = styled.div<Props>`
    display: flex;
    flex-direction: ${(p) => (p.isMobile ? 'column' : 'row')};
    margin-bottom: ${(p) => (p.isMobile ? '39px' : '64px')};
    width: 100%;
`;
export const SectionGrid = styled.div<Props>`
    display: ${(p) => (p.isMobile ? 'block' : 'grid')};
    grid-template-columns: 1fr 1fr 1fr;
    margin-bottom: 64px;
`;
export const Text = styled.div<Props>`
    margin-left: ${(p) => (p.isMobile ? null : '4vw')};
    max-width: ${(p) => (p.isMobile ? null : '588px')};
    width: ${(p) => (p.isMobile ? 'inherit' : null)};
    .text {
        margin-bottom: ${(p) => (p.isMobile ? null : '32px')};
    }
`;
export const Button = styled.button<Props>`
    color: #545453;
    border: 1px solid #cdcdcd;
    border-radius: 3px;
    padding: 12px 32px 12px 24px;
    width: ${(p) => (p.isMobile ? '100%' : null)};
    margin-top: ${(p) => (p.isMobile ? '16px' : null)};
    font-weight: 600;
    background: transparent;
    &:hover {
        color: black;
        border-color: black;
    }
`;
export const Linking = styled.a`
    color: black;
    text-decoration: underline;
    &:hover {
        color: #575b5e;
    }
`;
export const Card = styled.div<Props>`
    display: flex;
    flex-direction: column;
    max-width: ${(p) => (p.isMobile ? null : '270px')};
    width: ${(p) => (p.isMobile ? '100%' : null)};
`;
export const Photo = styled.img<Props>`
    width: ${(p) => (p.isMobile ? '100%' : '270px')};
    height: ${(p) => (p.isMobile ? '100%' : '270px')};
    background-image: ${(p) => p.src};
    margin-bottom: 16px;
`;
export const Line = styled.div<Props>`
    height: 1px;
    width: 100%;
    background-color: #575b5e;
    margin-bottom: ${(p) => (p.isMobile ? '40px' : '64px')};
    .star {
        margin: 0 auto;
        position: relative;
        bottom: 16px;
        z-index: 100;
        width: 40px;
        height: 40px;
    }
`;

export const ActionsButtonWrapper = styled(FlexBox)`
    position: relative;
     @media(max-width: ${LayoutConst.screen.s - 1}px) {
       width: 100%
    }
    .__react_component_tooltip {

        ::before {
            display: none;
        }
    }
`;
